/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XSquareIcon24Solid = forwardRef('XSquareIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.5 2A4.5 4.5 0 0 0 2 6.5v11A4.5 4.5 0 0 0 6.5 22h11a4.5 4.5 0 0 0 4.5-4.5v-11A4.5 4.5 0 0 0 17.5 2h-11Zm2.224 5.31A1 1 0 0 0 7.31 8.724L10.586 12 7.31 15.276a1 1 0 1 0 1.414 1.414L12 13.414l3.276 3.276a1 1 0 1 0 1.414-1.414L13.414 12l3.276-3.276a1 1 0 0 0-1.414-1.414L12 10.586 8.724 7.31Z" })));
});
